import React from 'react';
import moment from 'moment';

import CardFeed from '@buyside/components/presentation/CardFeed/cardFeed';
import ProfileImage from '@buyside/components/presentation/ProfileImage/profileImage';
import Button, { BUTTON_TYPES } from '@buyside/components/presentation/Button/button';

import BriefcaseIcon from '@buyside/svgs/briefcase.svg';

import { employerProfileVanityUrl } from '@buyside/util/urlHelper';
import { ActivityFeedEmployerProfileFragment } from '@interfaces/graphql-typings';

import styles from './fundProfileStyles.scss';

const FundProfile: React.FC<{ fundProfile: ActivityFeedEmployerProfileFragment }> = ({
  fundProfile
}): React.ReactElement => {
  const {
    aumRange,
    description,
    focus,
    foundingDate,
    fundManager,
    fundType,
    location,
    logoProfileUrl,
    name,
    strategy,
    vanityLink
  } = fundProfile;

  return (
    <CardFeed type="secondary">
      <header className={styles.fundHeader}>
        <div className={styles.profileImageWrap}>
          <ProfileImage size="medium" shape="square" source={logoProfileUrl} />
        </div>
        <div className={styles.fundHeaderContent}>
          <BriefcaseIcon className={styles.briefcaseIcon} />
          <h3 className={styles.headingTitle}>{name}</h3>
          <div className={styles.flex}>
            <div>
              <div className={styles.headingDataPoint}>
                <span className={styles.inlineLabelTitle}>Aum:</span> {aumRange || 'N/A'}
              </div>
              <div className={styles.headingDataPoint}>
                <span className={styles.inlineLabelTitle}>Founded:</span>{' '}
                {foundingDate ? moment(foundingDate).format('MMM D, YYYY') : 'N/A'}
              </div>
            </div>
            {fundManager && (
              <div>
                <div className={styles.profileDetails}>
                  <div className={styles.jobTitle}>Fund Manager</div>
                  <p>{fundManager}</p>
                </div>
              </div>
            )}
          </div>
        </div>
      </header>
      <div className={styles.cardBanner}>
        <div className={styles.cardBannerItem}>
          <div className={styles.cardBannerLabel}>Firm Type</div>
          <p>{fundType || 'N/A'}</p>
        </div>
        <div className={styles.cardBannerItem}>
          <div className={styles.cardBannerLabel}>Strategy</div>
          <p>{strategy || 'N/A'}</p>
        </div>
        <div className={styles.cardBannerItem}>
          <div className={styles.cardBannerLabel}>Focus</div>
          <p>{focus || 'N/A'}</p>
        </div>
        <div className={styles.cardBannerItem}>
          <div className={styles.cardBannerLabel}>Location</div>
          <p>{location || 'N/A'}</p>
        </div>
      </div>
      <div className={styles.fundBaseArea}>
        {description && <blockquote>{description.slice(0, 300) + '...'}</blockquote>}
        {vanityLink && (
          <Button
            type={BUTTON_TYPES.PRIMARY}
            icon={BriefcaseIcon}
            text="View Fund"
            url={employerProfileVanityUrl(vanityLink)}
          />
        )}
      </div>
    </CardFeed>
  );
};

export default FundProfile;
